import { getIndexAbove } from "../../utils/reordering/reordering";
import { SWStateRecordType, createStateId } from "../records/SWState";
import { SWStyleVariableGroupRecordType } from "../records/SWStyleVariableGroup";
export const ensureInterfaceStyleVariableGroup = (store)=>{
    const defaults = [
        {
            name: "background",
            value: "#FFFFFFFF"
        },
        {
            name: "primary",
            value: "#7478F8FF"
        },
        // { name: "secondary", value: "#AFB1FFFF" },
        {
            name: "text",
            value: "#000000FF"
        }
    ];
    const modes = [
        "light"
    ];
    modes.forEach((mode)=>{
        defaults.forEach(({ name, value })=>{
            const id = SWStateRecordType.createId(`style.interface.${name}.${mode}`);
            if (!store.has(id)) {
                store.put([
                    SWStateRecordType.create({
                        id: id,
                        defaultValue: {
                            type: "css-color",
                            value
                        }
                    })
                ]);
            }
        });
    });
    const deviceInterfaceStyle = SWStateRecordType.createId("device.interfaceStyle");
    if (!store.has(deviceInterfaceStyle)) {
        store.put([
            SWStateRecordType.create({
                id: deviceInterfaceStyle,
                defaultValue: {
                    type: "variable-string",
                    value: "light"
                },
                derivation: {
                    message: "This is set based on whether the device is in light or dark mode.",
                    derivation: "deviceInterfaceStyle"
                }
            })
        ]);
    }
    const interfaceStyleVariableGroup = SWStyleVariableGroupRecordType.createId("interface");
    if (!store.has(interfaceStyleVariableGroup)) {
        store.put([
            SWStyleVariableGroupRecordType.create({
                id: interfaceStyleVariableGroup,
                index: "a1",
                group: {
                    controlledBy: {
                        type: "state",
                        stateId: createStateId("device.interfaceStyle")
                    }
                }
            })
        ]);
    }
    // Create the modes & variables
    let indexes = [
        "a1"
    ];
    while(indexes.length < defaults.length){
        indexes.push(getIndexAbove(indexes[indexes.length - 1]));
    }
    modes.forEach((mode, index)=>{
        const modeStyleVariableGroup = SWStyleVariableGroupRecordType.createId(`interface.mode.${mode}`);
        if (!store.has(modeStyleVariableGroup)) {
            store.put([
                SWStyleVariableGroupRecordType.create({
                    id: modeStyleVariableGroup,
                    index: indexes[index]
                })
            ]);
        }
    });
    console.log("[!] indexes", indexes);
    const variables = defaults.map(({ name })=>name);
    variables.forEach((variable, index)=>{
        const variableStyleVariableGroup = SWStyleVariableGroupRecordType.createId(`interface.variable.${variable}`);
        if (!store.has(variableStyleVariableGroup)) {
            store.put([
                SWStyleVariableGroupRecordType.create({
                    id: variableStyleVariableGroup,
                    index: indexes[index],
                    variableType: {
                        type: "value-type",
                        value: "css-color"
                    }
                })
            ]);
        }
    });
};
